import useCommitteeReporting from './UseCommitteeReporting';

import ReportList from '@usas/ui-web/components/embeddedReports/ReportList';

const CommitteeReporting = () => {
  const { reportParameters, routeName } = useCommitteeReporting();

  return (
    <ReportList listTitle="Committee Reports"
      routeName={routeName}
      reportParameters={reportParameters} />
  );
};

export default CommitteeReporting;